/**
 * Company Update Mapper
 * Maps update requests from domain to transport layer
 */

import type { CompanyProfile } from '../types/companyProfile.types';

/**
 * Transport: Company update request for PUT /Company/update
 */
export interface LC_UpdateCompanyIn {
  companyId: number;
  companyRUT: string;
  companyDV: string;
  companyName: string;
  companyNameFantasy: string;
  terminateEmployeesWithExpiredContract: boolean;
  synchronizeWithREX: boolean;
  rexid: string | null;
  rexurl: string | null;
  companyAddress: string;
  companyAddressNumber: string;
  companyAddressRegionId: number;
  companyAddressCommuneId: number;
  estCompanyType: string | null;
  namePersonContact: string | null;
  emailPersonContact: string | null;
  telephonePersonContact: string | null;
}

/**
 * Maps CompanyProfile domain model to update request
 */
export function mapCompanyProfileToUpdateRequest(
  profile: CompanyProfile,
): LC_UpdateCompanyIn {
  return {
    companyId: profile.id,
    companyRUT: profile.rut,
    companyDV: profile.dv,
    companyName: profile.name,
    companyNameFantasy: profile.fantasyName,
    terminateEmployeesWithExpiredContract: profile.terminateExpiredContracts,
    synchronizeWithREX: profile.syncWithRex,
    rexid: profile.rexId || null,
    rexurl: profile.rexUrl || null,
    companyAddress: profile.address,
    companyAddressNumber: profile.addressNumber,
    companyAddressRegionId: profile.regionId,
    companyAddressCommuneId: profile.communeId,
    estCompanyType: profile.estType || null,
    namePersonContact: profile.contactName || null,
    emailPersonContact: profile.contactEmail || null,
    telephonePersonContact: profile.contactPhone || null,
  };
}
